<template>
  <div class="failureAccess">
    <i class="iconfont icon-shibai-icon icon"></i>
    <p class="title">暂无匹配信息</p>
    <div class="orderInfo">
      <div class="shell">
        <p class="list">
          <span class="fl">企业名称</span><span class="fr ">{{corpName}}</span>
        </p>
        <p class="list">
          <span class="fl">企业税号</span><span class="fr ">
            {{taxNo}}
          </span>
        </p>
      </div>
    </div>
    <Button
      text="返回首页"
      :type="danger"
      class="nextStep"
      :click="gohomePage"
    />
  </div>
</template>

<script>
import Button from '@/components/Button.vue';

export default {
  name: 'UnableAccess',
  data() {
    return {
      corpName: '',
      taxNo: '',
    };
  },
  created() {
    const {
      corpName, taxNo,
    } = this.$router.currentRoute.query;
    this.corpName = corpName;
    this.taxNo = taxNo;
  },

  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
  components: {
    Button,
  },
  methods: {
    gohomePage() {
      this.$router.push('/supermarket/v2');
    },
  },
};
</script>
<style scoped>
.failureAccess {
  padding-top: 100px;
}
.icon {
  color: #f5514a;
  font-size: 60px;
}
.reason {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 15px;
  color: #7c7c7c;
  font-size: 12px;
  text-align: left;
  background: #f8f9fb;
}
.none {
  display: none;
}
.seeDetail {
  color: #f55646;
}
.title {
  color: #1c2438;
  margin: 20px 0 0;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
  font-weight: bold;
}

.retry {
  float: left;
  width: 158px;
  margin-right: 8px;
  padding-right: 0;
  padding-left: 0;
}
.shell {
  box-sizing: border-box;
  width: 100%;
  padding-top: 15px;
  padding-right: 15px;
  padding-left: 15px;
}
.list {
  height: 44px;
  margin: 0;
  padding: 0;
  color: #495060;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
}
.fl {
  float: left;
  line-height: 22px;
  font-weight: 400;
}
.fr {
  float: right;
  width: 70%;
  line-height: 22px;
  text-align: right;
  font-weight: 400;
}
.reEvaluate {
  width: 345px;
  margin-top: 80px;
  color: #fff;
  font-size: 14px;
}
.teleInfo {
  color: #a2abb7;
  font-size: 12px;
  letter-spacing: 0;
  text-align: center;
}
.item {
  color: #fff;
}
.vanButton {
  background-color: none !important;
  border: none;
  color: rgb(255, 101, 56);
  padding: 0;
  margin: 0;
  height: 22px;
  float: right;
}
.reasonStyle {
  word-break: break-all;
}
.nextStep >>> button {
  background: #ff6538;
  border-radius: 8px;
  color: #fff;
}
.orderInfo {
  margin-top: 50px;
}
</style>
